import {useContext} from 'react';
import PropTypes from 'prop-types';
import FacebookIcon from "../utils/icons/FacebookIcon";
import InstagramIcon from "../utils/icons/InstagramIcon";
import TwitterIcon from "../utils/icons/TwitterIcon";
import {AppContext} from "../../App";

const ListingFooter = (props) => {
    const { t } = useContext(AppContext);

    const onSocialMediaClick = (link) => {
        window.open(link, '_blank');
    }

    const onInstagramClick = () => {
        onSocialMediaClick(props.socialMedia.instagram.link)
    }

    const onTwitterClick = () => {
        onSocialMediaClick(props.socialMedia.twitter.link)
    }

    const onFacebookClick = () => {
        onSocialMediaClick(props.socialMedia.facebook.link)
    }
    const contactUsLink = '/org/' + props.sellerId + '/contact?referral_url=' + encodeURIComponent(window.location.href);

    return (
        <div className={'listing-footer ' + props.className}>
            {props.organizationInfo?.isContactInfoVisible && (
                <div className='listing-footer__info-container'>
                    <div className='listing-footer__title text-xl-medium'>
                        {t('org_listing__contact_information')}
                    </div>
                    {props.organizationInfo?.address && <p className='text-md-regular'>
                        {props.organizationInfo?.address}
                    </p>}
                    {(props.organizationInfo?.city || props.organizationInfo?.state || props.organizationInfo?.zip || props.organizationInfo?.country) && (
                        <p className='text-md-regular'>
                            {props.organizationInfo?.city ? `${props.organizationInfo?.city}, ` : ''}
                            {props.organizationInfo?.state ? `${props.organizationInfo?.state}, ` : ''}
                            {props.organizationInfo?.zip ? `${props.organizationInfo?.zip}, ` : ''}
                            {props.organizationInfo?.country ? props.organizationInfo?.country : ''}
                        </p>)}
                    {props?.organizationInfo?.phone && <p className='text-md-regular'>{props.organizationInfo.phone}</p>}

                    <div className='listing-footer__link-container'>
                        {props.organizationInfo?.contactUs &&
                            <a target='_blank' href={contactUsLink} className='button button--default'>
                                {t('org_listing__contact_organizer')}
                            </a>}
                        {props.organizationInfo?.website &&
                            <a target='_blank' className='button button--default' href={props.organizationInfo.website}>
                                {t('org_listing__view_website')}
                            </a>}
                    </div>

                </div>
            )}

            {!props.isPro && (props.socialMedia.instagram || props.socialMedia.twitter || props.socialMedia.facebook) && (<div>
                <div className='listing-footer__icons-container'>
                    {props.socialMedia.twitter &&
                        <TwitterIcon onClick={onTwitterClick}/>
                    }

                    {props.socialMedia.instagram &&
                        <InstagramIcon onClick={onInstagramClick}/>
                    }

                    {props.socialMedia.facebook &&
                        <FacebookIcon onClick={onFacebookClick}/>
                    }
                </div>
            </div>)}
        </div>
    );
}

ListingFooter.propTypes = {
    className: PropTypes.string,
    organizationInfo: PropTypes.object.isRequired,
    socialMedia: PropTypes.object.isRequired,
}

ListingFooter.defaultProps = {
    className: '',
}

export default ListingFooter;
